import clsx from 'clsx';
import { FC } from 'react';

interface Props<T = {}> {
  desktop: FC<T>;
  mobile: FC<T>;
  props?: T;
  className?: string;
}

export const Responsive = <T extends {}>({ desktop, mobile, props, className }: Props<T>) => (
  <>
    <div className={clsx('hidden md:block', className)}>{desktop(props as T)}</div>
    <div className={clsx('block md:hidden', className)}>{mobile(props as T)}</div>
  </>
);
